import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=4762689b&scoped=true"
import script from "./ProductService.vue?vue&type=script&lang=js"
export * from "./ProductService.vue?vue&type=script&lang=js"
import style0 from "./ProductService.vue?vue&type=style&index=0&id=4762689b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4762689b",
  null
  
)

export default component.exports